module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"numbersOnly":"Whole numbers only","positiveOnly":"A positive number please","numbers":"Numbers please"},"es":{"numbersOnly":"Solo números enteros","positiveOnly":"Un número positivo por favor","numbers":"Números por favor"},"sw":{"numbersOnly":"Nambari nzima tu","positiveOnly":"Nambari chanya tafadhali","numbers":"Nambari tafadhali"}}')
  delete Component.options._Ctor
}
